<template>
    <div id="thumbnail-overlay" class="thumbnail-overlay">
        <img :src="getThumbnails" alt="videoImage"
             class="thumbnail-item" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const pathImage = computed(() => {
    //return store.getPathLocalOrServer;
    return store.getCloudFrontURL;
});

const getThumbnails = computed(() => {
    const weblinkID = store.getWeblinkID;
    const thumbnailsData = store.getVideoThumbnails;

    if (thumbnailsData.length > 0) {
        // filtrar las imagenes con typeImage = thumb
        const thumbnails = thumbnailsData.filter(thumbnail => thumbnail.typeImage === 'thumb');
        if (thumbnails.length === 0) {
            return '';
        }
        const randomIndex = Math.floor(Math.random() * thumbnails.length);
        let thumbnailImage = pathImage.value + 'videos/images/' + thumbnails[randomIndex].thumbnailImage;
        if (weblinkID > 0) {
            const value = store.getDataVariableByVariableName('thumbnail');
            if (value.length > 0) {
                thumbnailImage = pathImage.value + 'images_variables/' + value[0].path;
            }
        }
        return thumbnailImage; //store.getVideoData.videoImage;
    }
    return '';
});

// METHODS

// LIFECYCLE HOOKS
</script>
